import { useCache } from '@/hooks/web/useCache'
import { APP_VERSION } from '@/config/global'

const { wsCache } = useCache()

export type LayoutType = 'classic' | 'topLeft' | 'top' | 'cutMenu'

// export type ThemeTypes = {
//   elColorPrimary?: string
//   leftMenuBorderColor?: string
//   leftMenuBgColor?: string
//   leftMenuBgLightColor?: string
//   leftMenuBgActiveColor?: string
//   leftMenuCollapseBgActiveColor?: string
//   leftMenuTextColor?: string
//   leftMenuTextActiveColor?: string
//   logoTitleTextColor?: string
//   logoBorderColor?: string
//   topHeaderBgColor?: string
//   topHeaderTextColor?: string
//   topHeaderHoverColor?: string
//   topToolBorderColor?: string
// }

export type ChartColor = {
  text?: string
  label?: string
  title?: string
  line?: string
  border?: string
  legendTxt?: string
  zoomBorder?: string
  zoomBg?: string
  zoomFill?: string
  zoomFillBorder?: string
  zoomCurFill?: string

  blue?: string
  green?: string
  red?: string
  orange?: string
  yellow?: string
  brightBlue?: string
  purple?: string
  limeGreen?: string
  brightpink?: string
  
  greenBg?: string
  redBg?: string
  orangeBg?: string

  popperBorder?: string
  popperBg?: string
}
export type Icon = {
  // 定义为“字符串键 -> 字符串值”的索引类型，支持动态属性
  [key: string]: string;
}
export interface AppState {
  version: string
  breadcrumb: boolean
  breadcrumbIcon: boolean
  collapse: boolean
  uniqueOpened: boolean
  hamburger: boolean
  screenfull: boolean
  size: boolean
  locale: boolean
  tagsView: boolean
  tagsViewIcon: boolean
  logo: boolean
  fixedHeader: boolean
  greyMode: boolean
  dynamicRouter: boolean
  pageLoading: boolean
  layout: LayoutType
  title: string
  userInfo: string
  isDark: boolean
  currentSize: ElememtPlusSize
  sizeMap: ElememtPlusSize[]
  mobile: boolean
  footer: boolean
  hideMenu: boolean
  hideHeader: boolean
  theme: string,
  hideDialog: boolean,
  chartColor: ChartColor,
  icons: Icon
}

export const appModules: AppState = {
  version: APP_VERSION,
  userInfo: 'userInfo', // 登录信息存储字段-建议每个项目换一个字段，避免与其他项目冲突
  sizeMap: ['default', 'large', 'small'],
  mobile: false, // 是否是移动端
  title: import.meta.env.VITE_APP_TITLE, // 标题
  pageLoading: false, // 路由跳转loading

  breadcrumb: true, // 面包屑
  breadcrumbIcon: true, // 面包屑图标
  collapse: false, // 折叠菜单
  uniqueOpened: false, // 是否只保持一个子菜单的展开
  hamburger: true, // 折叠图标
  screenfull: true, // 全屏图标
  size: true, // 尺寸图标
  locale: true, // 多语言图标
  tagsView: true, // 标签页
  tagsViewIcon: true, // 是否显示标签图标
  logo: true, // logo
  fixedHeader: true, // 固定toolheader
  footer: true, // 显示页脚
  greyMode: false, // 是否开始灰色模式，用于特殊悼念日
  dynamicRouter: wsCache.get('dynamicRouter') || false, // 是否动态路由

  layout: wsCache.get('layout') || 'classic', // layout布局
  isDark: wsCache.get('isDark') || false, // 是否是暗黑模式
  currentSize: wsCache.get('default') || 'default', // 组件尺寸
  hideMenu: false, // 隐藏菜单
  hideHeader: false, // 隐藏header
  theme: 'light',
  // theme: wsCache.get('theme') || {
  //   // 主题色
  //   // elColorPrimary: '#409eff',
  //   // // 左侧菜单边框颜色
  //   // leftMenuBorderColor: 'inherit',
  //   // // 左侧菜单背景颜色
  //   // leftMenuBgColor: '#f0f0f0',
  //   // // 左侧菜单浅色背景颜色
  //   // leftMenuBgLightColor: '#0f2438',
  //   // // 左侧菜单选中背景颜色
  //   // leftMenuBgActiveColor: '#f0f0f0',
  //   // // 左侧菜单收起选中背景颜色
  //   // leftMenuCollapseBgActiveColor: '#f0f0f0',
  //   // // 左侧菜单字体颜色
  //   // leftMenuTextColor: '#323233',
  //   // // 左侧菜单选中字体颜色
  //   // leftMenuTextActiveColor: '#008CD6',
  //   // // logo字体颜色
  //   // logoTitleTextColor: '#fff',
  //   // // logo边框颜色
  //   // logoBorderColor: 'inherit',
  //   // // 头部背景颜色
  //   // topHeaderBgColor: '#fff',
  //   // // 头部字体颜色
  //   // topHeaderTextColor: 'inherit',
  //   // // 头部悬停颜色
  //   // topHeaderHoverColor: '#f6f6f6',
  //   // // 头部边框颜色
  //   // topToolBorderColor: '#eee'
  // },
  hideDialog: false,
  chartColor:{
    text:'#323233',
    label:'#787878',
    title:'#555',
    line:'#E1E1E1',
    border:'#C8C8C8',
    legendTxt:'#787878',

    blue: '#3381D6',
    green: '#00B900',
    red: '#DF001A',
    orange: '#FF9300',
    yellow: '#EBC147',
    brightBlue: '#EBC147',
    purple: '#8048C8',
    limeGreen: '#4BD8A5',
    brightpink: '#FB4788',          
    greenBg: '#E1F7E1',
    redBg: '#FBE1E4',
    orangeBg: '#FFEFDA', 
    
    popperBorder: '#FFF', 
    popperBg: '#FFF', 
  },
  icons: {
    success: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.9999 2C17.5224 2 22 6.47757 22 11.9999C22 17.5224 17.5224 22 11.9999 22C6.47757 22 2 17.5224 2 11.9999C2 6.47757 6.47757 2 11.9999 2Z" fill="currentColor"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.706 8.72736L9.99962 17.4342L5.29297 12.7273L6.70685 11.3134L9.99962 14.6061L17.292 7.31348L18.706 8.72736Z" fill="white"/>
              </svg>
            `
  }
}
